// @catalog F.006
// Vistas secundarias del subnav de /ventas (Tiendas POS / Vendedores SO /
// Productos). Extraídas de DashboardVentas.tsx para respetar P7 (≤500 líneas).
import {
  Alert,
  Card,
  CardContent,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import type {
  StoreMetrics,
  TopProductMonthly,
} from "../../services/analytics.service";
import { StoresPOSTable } from "./StoresPOSTable";
import { VendorsTable } from "./VendorsTable";
import { TopProductsTable } from "./TopProductsTable";

const CARD_SX = {
  backgroundColor: "var(--surface)",
  border: "1px solid var(--border)",
  boxShadow: "none",
} as const;

export function TiendasView(props: {
  stores: StoreMetrics[];
  fetching: boolean;
}): JSX.Element {
  const { stores, fetching } = props;
  return (
    <Card sx={CARD_SX}>
      <CardContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
          Tiendas POS — análisis completo
        </Typography>
        {stores.length === 0 ? (
          <Alert severity="info">
            No hay datos de tiendas POS para el rango seleccionado
          </Alert>
        ) : (
          <StoresPOSTable stores={stores} />
        )}
        {fetching && (
          <Stack direction="row" justifyContent="center" sx={{ py: 2 }}>
            <CircularProgress size={20} />
          </Stack>
        )}
      </CardContent>
    </Card>
  );
}

export function VendedoresView(props: {
  vendors: StoreMetrics[];
}): JSX.Element {
  const { vendors } = props;
  return (
    <Card sx={CARD_SX}>
      <CardContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
          Vendedores SO — análisis completo
        </Typography>
        {vendors.length === 0 ? (
          <Alert severity="info">
            No hay datos de vendedores para el rango seleccionado
          </Alert>
        ) : (
          <VendorsTable vendors={vendors} />
        )}
      </CardContent>
    </Card>
  );
}

export function ProductosView(props: {
  products: TopProductMonthly[];
  periodDescriptor: string;
  onProductClick?: (productId: number, productName: string) => void;
}): JSX.Element {
  const { products, periodDescriptor, onProductClick } = props;
  return (
    <Card sx={CARD_SX}>
      <CardContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
          Productos — top {products.length} · {periodDescriptor}
        </Typography>
        <TopProductsTable
          products={products}
          {...(onProductClick && { onProductClick })}
        />
      </CardContent>
    </Card>
  );
}
